import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/mdxLayouts/ProjectsLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Introduction`}</h2>
    <p>{`For this freelance project, I had to create a website for a small notary business in Washington state. The project called for a three-page site to show potential customers what is being offered, who is running the business, and how to reach out for services. After speaking with the client I decided to use some very cost-effective tech that would keep her business site free to run and maintain.`}</p>
    <h2>{`What was used`}</h2>
    <p>{`Due to budget constraints, I decided to use NetlifyCMS, Netlify, and Gatsby. This is a highly cost-effective combination of tech that leads to no overhead cost for CMS and hosting. For UI and UX I used styled-components and Framer Motion. I have found that these libraries synergize very well together and lead to a site that feels more alive and interactive to the user.`}</p>
    <h2>{`Gatsby`}</h2>
    <p>{`Gatbsy has been my go-to for client sites, because of its diverse collection of plugins that are available. While coding out most of these features wouldn't be the most difficult having everything prebuilt comes in handy when working within a budget. Gatbsy also integrates very well with any git and markdown based CMS which made querying for content painless.`}</p>
    <h2>{`NetlifyCMS and Netlify`}</h2>
    <p>{`I have used NetlifyCMS before in a previous portfolio and found that using a git based CMS has great advantages. For this project specifically, I found this choice was likely not right for the client. While NetlifyCMS's interface isn't difficult to use for the developer making the site the client found it difficult to use and we ran into several issues when it came to ease of use. As I'm sure you can imagine based on name alone, NetlifyCMS and Netlify are greatly synergistic and easy to set up for developers. I chose Netlify for my hosting platform because they have a very generous free tier that my client could take advantage of. Netlify also has built-in continuous integration with Gatsby which makes pushing updates to the site seamless.`}</p>
    <h2>{`Styled-Components`}</h2>
    <p>{`Styled-components has been a great boost to my productivity when developing UI heavy sites. Not having to worry about CSS/SCSS imports has made creating consistent styles much easier. The primary reason I chose to use this library is due to the SCSS style of writing CSS. Creating components that have nested styles makes working with markdown files much easier as you can write all of your substyles in your component and set the inner HTML to be your content.`}</p>
    <h2>{`Framer Motion`}</h2>
    <p>{`Being able to use Framer Motion for animations made working with styled-components much easier. The biggest roadblock for me using styled-components was the difficult use of animations. Creating a styled motion component made it easy to create aesthetically appealing elements with smooth spring animations to grab the user's attention.`}</p>
    <h2>{`Conclusion`}</h2>
    <p>{`While all of the libraries used in their project were synergistic and led to a great developer experience, I found that the customer experience definitely lacked. Having to walk through every aspect of how the CMS works were frustrating for both of us at times and if I had the opportunity today I would have taken a different approach. Using a CMS such as DatoCMS or WordPress would have been much more of a benefit for both of us. I really enjoy the styled-components and Framer Motion workflow. There is certainly downsides when it comes to the speed at which you can develop with these libraries in comparison to a CSS framework like Tailwind CSS, but I still find this to be my go-to when animations are crucial to the brand.`}</p>
    <p>{`I hope you enjoyed the breakdown for HC Notary and I encourage you to check out the site to see how I have grown as a developer. If you have anything you would like to add send me a message through my contact button or email me at `}<a parentName="p" {...{
        "href": "mailto:ethan@eolsen.dev."
      }}>{`ethan@eolsen.dev.`}</a>{` Thank you for reading and keep on coding!`}</p>

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  .grvsc-container {
    overflow: auto;
    position: relative;
    -webkit-overflow-scrolling: touch;
    padding-top: 1rem;
    padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
    padding-bottom: 1rem;
    padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
    border-radius: 8px;
    border-radius: var(--grvsc-border-radius, 8px);
    font-feature-settings: normal;
    line-height: 1.4;
  }
  
  .grvsc-code {
    display: table;
  }
  
  .grvsc-line {
    display: table-row;
    box-sizing: border-box;
    width: 100%;
    position: relative;
  }
  
  .grvsc-line > * {
    position: relative;
  }
  
  .grvsc-gutter-pad {
    display: table-cell;
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  .grvsc-gutter {
    display: table-cell;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter::before {
    content: attr(data-content);
  }
  
  .grvsc-source {
    display: table-cell;
    padding-left: 1.5rem;
    padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
    padding-right: 1.5rem;
    padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  }
  
  .grvsc-source:empty::after {
    content: ' ';
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  }
  
  .grvsc-gutter + .grvsc-source {
    padding-left: 0.75rem;
    padding-left: calc(var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem)) / 2);
  }
  
  /* Line transformer styles */
  
  .grvsc-has-line-highlighting > .grvsc-code > .grvsc-line::before {
    content: ' ';
    position: absolute;
    width: 100%;
  }
  
  .grvsc-line-diff-add::before {
    background-color: var(--grvsc-line-diff-add-background-color, rgba(0, 255, 60, 0.2));
  }
  
  .grvsc-line-diff-del::before {
    background-color: var(--grvsc-line-diff-del-background-color, rgba(255, 0, 20, 0.2));
  }
  
  .grvsc-line-number {
    padding: 0 2px;
    text-align: right;
    opacity: 0.7;
  }
  
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      